import { Component, Input } from '@angular/core';

/**
 * Spinner de página/formulário.
 *
 * Convenção B2B / OS / Agendamentos:
 * - Listas com `app-table`: use só `[loading]` da tabela (não combine com este componente).
 * - Formulários / detalhe: use só `app-loading`.
 * - Na entrada da tela, um único indicador — evite 2+ overlays para o mesmo carregamento.
 */
@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css']
})
export class LoadingComponent {
  @Input() show: boolean = false;
  @Input() message: string = 'Carregando...';
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() overlay: boolean = true;
}
